import { g as r } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as s, createElementBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDissatisfied",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function h(e, i, d, _, g, t) {
  return s(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--dissatisfied"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Dissatisfied",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM4 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm3 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5ZM4.237 7.096c.4-.29 1-.596 1.763-.596.763 0 1.364.305 1.763.596a3.474 3.474 0 0 1 .62.582l.01.014.005.005v.002H8.4L8 8l.4-.3a.5.5 0 0 1-.798.602L7.599 8.3a2.474 2.474 0 0 0-.425-.395A1.995 1.995 0 0 0 6 7.5c-.487 0-.886.195-1.175.404a2.474 2.474 0 0 0-.424.395l-.002.003A.5.5 0 0 1 3.6 7.7L4 8l-.4-.3.001-.001.001-.002.004-.005.01-.014c.01-.01.021-.025.036-.042a3.474 3.474 0 0 1 .585-.54Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const D = /* @__PURE__ */ u(c, [["render", h]]);
export {
  D as default
};
//# sourceMappingURL=dissatisfied.js.map
